import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

function TipsPage() {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>సలహాలు & భద్రతా మార్గదర్శకాలు</Typography>
      
      <Typography variant="h6" sx={{ mt: 3 }}>మీరు ఒక వస్తువును పోగొట్టుకుంటే:</Typography>
      <ul>
        <li><Typography>వివరంగా ఉండండి: పోగొట్టుకున్న వస్తువును రిపోర్ట్ చేసేటప్పుడు, మీకు మాత్రమే తెలిసిన ప్రత్యేకమైన గుర్తులు, గీతలు, లేదా వివరాలతో సహా పూర్తి వివరణ ఇవ్వండి.</Typography></li>
        <li><Typography>ఓపికగా ఉండండి: ఎవరైనా మీ వస్తువును కనుగొని పోస్ట్ చేయడానికి కొంత సమయం పట్టవచ్చు. వెబ్‌సైట్‌ను క్రమం తప్పకుండా తనిఖీ చేయండి.</Typography></li>
        <li><Typography>ధృవీకరణను ఉపయోగించండి: ఎవరైనా మీ వస్తువును కనుగొన్నట్లు క్లెయిమ్ చేస్తే, చాట్‌లోని "Verify Ownership" ఫీచర్‌ను ఉపయోగించి వారు సరైన వ్యక్తి అని నిర్ధారించుకోండి.</Typography></li>
      </ul>

      <Typography variant="h6" sx={{ mt: 3 }}>మీకు ఒక వస్తువు దొరికితే:</Typography>
      <ul>
        <li><Typography>వెంటనే పోస్ట్ చేయండి: మీరు వస్తువును ఎంత త్వరగా పోస్ట్ చేస్తే, యజమాని దానిని కనుగొనే అవకాశాలు అంత ఎక్కువగా ఉంటాయి.</Typography></li>
        <li><Typography>రహస్య గుర్తులను పంచుకోవద్దు: మీ పబ్లిక్ పోస్ట్ వివరణలో, చాలా నిర్దిష్టమైన గుర్తులను పేర్కొనవద్దు. వీటిని రహస్యంగా ఉంచండి, తద్వారా మీరు వాటిని చాట్‌లో ధృవీకరణ ప్రశ్నలుగా ఉపయోగించవచ్చు.</Typography></li>
        <li><Typography>ప్రజా ప్రదేశంలో కలవండి: ఒక వస్తువును తిరిగి ఇచ్చేటప్పుడు, ఎల్లప్పుడూ పగటిపూట సురక్షితమైన, ప్రజా ప్రదేశంలో కలవడానికి ఏర్పాటు చేసుకోండి. మీ మీటింగ్ గురించి ఒక స్నేహితుడికి లేదా కుటుంబ సభ్యునికి తెలియజేయండి.</Typography></li>
      </ul>

       <Typography variant="h6" sx={{ mt: 3 }}>సాధారణ భద్రత:</Typography>
      <ul>
        <li><Typography>మీ గోప్యతను కాపాడుకోండి: మీ ఇంటి చిరునామా వంటి వ్యక్తిగత సమాచారాన్ని పంచుకోవడం మానుకోండి. అన్ని ప్రారంభ కమ్యూనికేషన్‌ల కోసం ఇన్-యాప్ చాట్‌ను ఉపయోగించండి.</Typography></li>
        <li><Typography>మోసాల పట్ల జాగ్రత్తగా ఉండండి: షిప్పింగ్ లేదా ఇతర ఫీజుల కోసం డబ్బు అడిగే ఎవరితోనైనా జాగ్రత్తగా ఉండండి. చాలా మంది నిజాయితీగల ఫైండర్లు డబ్బు అడగరు.</Typography></li>
        <li><Typography>అనుమానాస్పద కార్యకలాపాలను రిపోర్ట్ చేయండి: మీరు ఒక మోసపూరిత పోస్ట్ లేదా అనుమానాస్పద యూజర్‌ను ఎదుర్కొంటే, వెంటనే "Report" ఫీచర్‌ను ఉపయోగించండి, తద్వారా మా అడ్మిన్ బృందం దర్యాప్తు చేయగలదు.</Typography></li>
      </ul>
    </Paper>
  );
}

export default TipsPage;
